import { Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useRef } from "react";
import BoldHeading from "../components/BoldHeading";
import Section from "../components/Section";
import SideContent from "../components/SideContent";
import { useIsVisible } from "../hooks/useIsVisible";
import intro1 from "../images/NewUI/intro1.png";
import intro2 from "../images/NewUI/intro2.png";
import intro3 from "../images/NewUI/intro3.png";
import leftEffect from "../images/NewUI/left_effect.png";

const IntroduceSection = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  return (
    <>
      <Section py="0" sx={{ position: "relative", zIndex: 1 }}>
        <BoldHeading align="center">INTRODUCE</BoldHeading>
        <Typography variant="h4" align="center" fontWeight={700} my={0.5}>
          SIX Protocol’s NFTgen2
        </Typography>

        <Typography
          align="center"
          sx={{ maxWidth: "640px", mx: "auto" }}
          whiteSpace="pre-line"
        >
          {`NFT Gen 2 is the on-chain solution on SIX Protocol, developed by SIX Network. The purpose of creating NFT Gen 2 is to enhance the real utility to the NFT and make businesses able to implement NFT for real-world business activities.\nAlso, it is user-friendly and ready to use with any NFT collections on any chain.`}
        </Typography>
      </Section>

      <Section containerClass="d-flex flex-wrap align-center" pb="0">
        <SideContent>
          <img src={intro1} alt="" width="400px" />
        </SideContent>
        <SideContent isLarge isRight>
          <BoldHeading mb={2}>Dynamic Data Layer</BoldHeading>
          <Typography whiteSpace="pre-line">
            {`The Dynamic Data Layer is responsible for storing and exchanging Dynamic Metadata of specific NFTs, is designed to be user-friendly and compatible with any blockchain platform. along with the unique characteristics of the chain’s binary, which enable businesses to engrave the usage such as ticketing, coupon, campaign, and other marketing data on individual NFT.`}
          </Typography>
        </SideContent>
      </Section>

      <Section
        containerClass={`d-flex flex-wrap align-center ${
          !md ? "flex-column-reverse" : ""
        }`}
        pb="0"
      >
        <SideContent isLarge>
          <BoldHeading>Ability</BoldHeading>
          <Typography variant="h4" my={2} fontWeight="normal" lineHeight={1.2}>
            to Implement with Any NFT Collections on Any Chains
          </Typography>
          <Typography>
            SIX Protocol's NFT Gen 2 can be seamlessly integrated into any
            existing NFT collection, no matter which blockchain network it is
            based in. This feature is valuable for businesses looking to expand
            their NFT offerings across different blockchain, as it allows for
            cross-chain communication.
          </Typography>
        </SideContent>
        <SideContent>
          <img src={intro2} alt="" width="400px" />
        </SideContent>
      </Section>

      <Section containerClass="d-flex flex-wrap align-center p-relative" pb="0">
        <Fade in={isVisible} {...(isVisible ? { timeout: 3000 } : {})}>
          <img
            ref={ref}
            src={leftEffect}
            alt=""
            width="30%"
            style={{ position: "absolute", top: "0", left: "0" }}
          />
        </Fade>
        <SideContent
          sx={{
            overflow: { xs: "hidden", md: "initial" },
            position: "relative",
            zIndex: 1,
          }}
        >
          <img
            src={intro3}
            alt=""
            width="640px"
            style={{ maxWidth: "initial" }}
          />
        </SideContent>
        <SideContent isLarge isRight>
          <BoldHeading>Proof of Ownership</BoldHeading>
          <Typography variant="h4" my={2} fontWeight="normal" lineHeight={1.2}>
            with NFT Oracle
          </Typography>
          <Typography>
            When signing messages from other blockchain networks to merge
            Dynamic Metadata to the Dynamic Data Layer, NFT Gen 2 will utilize
            oracle to verify the ownership of the original message to ensure
            proof of ownership and prevent fraud. Since the original Metadata of
            an NFT can merge with the Dynamic Metadata on SIX Protocol, which
            will be embedded on the NFT for users' utility access and usage.
          </Typography>
        </SideContent>
      </Section>
    </>
  );
};

export default IntroduceSection;
